import React from 'react';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

function StoreActionCard({ icon, label, description, onClick }) {
    return (
        <Card sx={{ width: '100%', flex: { md: '1 1 240px' }, minWidth: 0 }}>
            <CardActionArea
                onClick={onClick}
                sx={{
                    px: { xs: 2.5, sm: 3 },
                    py: { xs: 2.25, sm: 2.75 },
                }}
            >
                <Stack direction="row" spacing={2.5} alignItems="center">
                    <Box
                        sx={{
                            flexShrink: 0,
                            width: 52,
                            height: 52,
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: 'rgba(123, 47, 247, 0.14)',
                            color: 'primary.main',
                        }}
                    >
                        {icon}
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
                            {label}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {description}
                        </Typography>
                    </Box>
                </Stack>
            </CardActionArea>
        </Card>
    );
}

export default StoreActionCard;
